/**
 * `/accounts/:accountId/assistants/:AssistantID/myassistant/metrics` — the only
 * place the agent's metrics are mounted (`AppRouter.tsx`, the `myassistant`
 * group). Anchored at both ends, so anything nested below never matches; a
 * substring test would also catch the account-level `/metrics` section or an id
 * that happens to contain the segment.
 */
const METRICS_ROUTE = /^\/accounts\/[^/]+\/assistants\/[^/]+\/myassistant\/metrics\/?$/;

export function isMetricsPath(pathname: string): boolean {
  return METRICS_ROUTE.test(pathname);
}
